/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { array, shape, string } from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    wrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        flexDirection: 'column',
        margin: '20px 0px 15px 0px',
        width: '100px',
        '&:not(:last-child)': {
            marginRight: 'clamp(2.6rem, 2vw, 2rem)',
        },
        '@media screen and (min-width: 1024px) and (max-width: 1366px)': {
            width: '75px',
            '&:not(:last-child)': {
                marginRight: '2em',
            },
        },
        [theme.breakpoints.down(1024)]: {
            width: '75px',
            '&:not(:last-child)': {
                marginRight: '0.6em',
            },
        },
        [theme.breakpoints.down(767)]: {
            width: '60px',
            '&:not(:last-child)': {
                marginRight: '0.6em',
            },
        },
    },
    title: {
        margin: '6px 0px 0px 0px',
        fontSize: '14px',
        textAlign: 'center',
    },
}));

const ProductAttributeIconsCMS = ({
    data, productAttributes,
}) => {
    const classes = useStyles();
    const certificateIcons =  data?.certifications || [];
    const certificateValue = (productAttributes || [])?.find?.((attribute) => attribute?.name === 'certifications')?.values || [];
    if (certificateValue.length === 0  || certificateIcons.length === 0) return '';
    return (
        <div className={classes.container}>
            {
                certificateValue?.map((attribute) => certificateIcons?.map((items) =>  ((
                    attribute.value?.toLowerCase()  === items?.pim_data_value?.toLowerCase())
                    && (
                        <div className={classes.wrapper}>
                            <img src={items.icon?.url} alt={items?.icon_title} />
                            <div className={classes.title}>{items?.icon_title}</div>
                        </div>
                    )
                )))

            }
        </div>
    );
};
ProductAttributeIconsCMS.propTypes = {
    productAttributes: array,
    data: shape({
        value: string.isRequired,
        key: string.isRequired,
    }).isRequired,
};
ProductAttributeIconsCMS.defaultProps = {
    productAttributes: [],
};
export default (ProductAttributeIconsCMS);
